var App = App || {};

App.EventsBand = (function ($) {
    "use strict";

    function init() {

        const eventsBands = $(".block.block-eventsband");
        if (eventsBands.length) {
            eventsBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(eventsBand) {
        const carousel = eventsBand.find(".splide");

        if (carousel.length) {
            var count = carousel.data("count");

            //ensure duplicate cards are not visible
            let mdWidth, smWidth, xsWidth;
            switch (count) {
                case 3:
                    mdWidth = "32rem";
                    smWidth = xsWidth = "26.4rem";
                    break;
                case 2:
                    mdWidth = "49rem";
                    smWidth = "38rem";
                    xsWidth = "26.4rem";
                    break;
                default:
                    mdWidth = smWidth = xsWidth = "26.4rem";
            }

            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'loop',
                fixedWidth: "36.3rem",
                gap: "11px",
                drag: true,
                snap: false,
                perMove: 1,
                breakpoints: {
                    991: {
                        fixedWidth: mdWidth,
                    },
                    767: {
                        fixedWidth: smWidth,
                    },
                    575: {
                        fixedWidth: xsWidth,
                    },
                }
            });

            splideCarousel.mount();

            const nextBtn = eventsBand.find(".carousel-btn.carousel-next");
            const prevBtn = eventsBand.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideCarousel.go('+1')
            });

            prevBtn.on("click", function () {
                splideCarousel.go('-1')
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.EventsBand.init();
});